//
//

import { uid } from "quasar";
import aurachainAppLogo from "@/assets/images/InternalEntity.svg";
import externalAppLogo from "@/assets/images/ExternalEntity.svg";
import { mapActions, mapGetters, mapMutations } from "vuex";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import CreateEntityModalNew from "./CreateEntityModalNew.vue";
import CreateColumnModal from "./CreateColumnModal.vue";
import HistoryModal from "./Audit/HistoryModal.vue";
import ImportEntityModal from "./ImportEntityModal.vue";
import CreateEntityExternalSource from "./CreateEntityExternalSource.vue";
import TablesList from "./TablesList.vue";
import { DUMMY_TABLE_DATA, DUMMY_TABLE_COLUMNS } from "./consts";
import EntityTable from "./EntityTable.vue";

export default {
    name: "GlobalFeaturesNew",
    components: {
        CreateEntityModalNew,
        CreateColumnModal,
        TablesList,
        EntityTable,
        CreateEntityExternalSource,
        FabricSearch,
        HistoryModal,
        AQDialog,
        ImportEntityModal,
        AQModal
    },
    beforeRouteUpdate(to, from, next) {
        if (!to.params.tableCode && from?.params.tableCode) {
            this.getEntities([]).then(({ data }) => {
                this.emptyState = !data.length;
                this.entityList = data;
                this.skeletonState = false;
                this.showEntityTable = false;
                this.search = "";
                this.updateNotify();
                this.$root.$emit("hideSaveBtn", true);
                this.$oneAtATime.destroyCurrentRoom();
                this.openChangeHistoryModal();
                this.showEntityList = true;
                this.firstLoad = false;
            });
        } else if (!from.query.search && to.query.search) {
            this.$root.$emit("showCheckedSaveBtn", false);
            this.$store.commit("main/setSaveBtnVisible", true);
        }
        next();
    },
    data() {
        return {
            openCreateEntityModalNew: false,
            openImportEntityModal: false,
            rowIdsSet: new Set(),
            sourceOptions: [
                {
                    value: "aurachain",
                    label: ""
                }
            ],
            isHovered: false,
            invalidCellIds: {},
            search: "",
            columns: DUMMY_TABLE_COLUMNS,
            entityList: [],
            openAttributeModal: false,
            tableData: DUMMY_TABLE_DATA,
            tableDefaultSelectionList: [],
            resetCurrentPage: false,
            showMenu: [],
            headerOptions: [
                {
                    value: "permissions",
                    label: this.$t("globalDataModel.permissions"),
                    itemDisabled: false
                },
                {
                    value: "edit",
                    label: this.$t("globalDataModel.editEntity"),
                    itemDisabled: false
                },
                {
                    value: "export",
                    label: this.$t("globalDataModel.export"),
                    itemDisabled: false
                },
                {
                    value: "importData",
                    label: this.$t("globalDataModel.importData"),
                    itemDisabled: false
                },
                {
                    value: "dataAudit",
                    label: this.$t("globalDataModel.dataAudit"),
                    itemDisabled: false
                },
                {
                    value: "deleteData",
                    label: this.$t("globalDataModel.deleteData"),
                    itemDisabled: false
                },
                {
                    value: "deleteTable",
                    label: this.$t("globalDataModel.deleteTable"),
                    itemDisabled: false
                }
            ],
            openEditModal: false,
            deleteEntityDialog: false,
            entityForDeletion: "",
            entityDataForEdit: {},
            selectedEntity: "",
            selectedRowOnHover: null,
            entityIsPublished: true,
            openAttEdit: false,
            attDataToEdit: {},
            attIsPublished: null,
            focusedCell: null,
            cellValueChanged: false,
            localEntity: {},
            savedTableData: [],
            activeEntityCode: null,
            loadingData: true,
            loadingDummyColumns: true,
            noDataInEntity: false,
            okActionEntity: null,
            updateNotify: () => {},
            bulkDeleteMode: false,
            rowIdSet: new Set(),
            appLogo: aurachainAppLogo,
            externalLogo: externalAppLogo,
            showEntityTable: false,
            showEntityList: true,
            skeletonState: true,
            emptyState: false,
            errorRetrievingData: false,
            attributesListToSend: [],
            nothingToSave: true,
            entityNameForToast: "",
            deleteColumn: {
                name: "deleteColumn",
                align: "center",
                label: "",
                field: "column0",
                visible: true,
                id: uid()
            },
            tablePagination: {
                rowsPerPage: 10,
                page: 1,
                total: 0,
                from: 0,
                to: 10
            },
            iid: Symbol("internal id"),
            firstLoad: false,
            resetLinkFromBC: false,
            changeHistoryModal: false
        };
    },
    computed: {
        ...mapGetters("main", ["getInfoApp"]),
        ...mapGetters("dataStore", ["publishStatus", "exportFinished", "getImportInProgress", "getSelectedEntity", "getEntitySelected"]),
        entityDetails() {
            return {
                code: this.entityDataForEdit.code,
                name: this.entityDataForEdit.name
            };
        },
        createEntModalProps() {
            return {
                sourceOptions: this.sourceOptions,
                isEdit: this.openEditModal,
                dataToEdit: this.entityDataForEdit,
                entityIsPublished: this.entityIsPublished,
                entityList: this.entityList,
                tableData: this.savedTableData
            };
        },
        headerMenu() {
            const [permissions, edit, exportData, importData, deleteData] = this.headerOptions;
            if (this.isExternal) {
                if (!this.$oneAtATime.state.$currentRoomEmpty) {
                    return [
                        { ...edit, itemDisabled: true }
                    ];
                }
                return [edit];
            }
            if (!this.$oneAtATime.state.$currentRoomEmpty) {
                return [
                    { ...importData, itemDisabled: true },
                    exportData,
                    { ...deleteData, itemDisabled: true },
                    { ...edit, itemDisabled: true },
                    { ...permissions, itemDisabled: true }
                ];
            }
            return [permissions, edit, exportData, importData, { ...deleteData, itemDisabled: !this.tableData.length }];
        },
        isExternal() {
            // return this.localEntity.type !== "aurachain";
            return false;
        },
        readOnly() {
            return !this.$oneAtATime.state.$currentRoomEmpty || this.isExternal;
        },
        ddlSelectContract() {
            return {
                dataList: this.booleanOptions,
                hideCheckbox: true,
                closeOnSelection: true,
                hideClearDataIcon: false
            };
        },
        filteredList() {
            let entities = [];
            const lowerCaseValue = this.search.toLowerCase();
            entities = this.entityList.filter(entity => (entity.name || "").toLowerCase().includes(lowerCaseValue)
            || (entity.code).toLowerCase().includes(lowerCaseValue));
            return entities;
        }
    },
    watch: {
        getImportInProgress: {
            handler(newValue) {
                this.setImportDataDisable(newValue);
                if (!newValue) {
                    this.showEntity({ code: this.activeEntityCode });
                }
            }
        },
        nothingToSave: {
            handler(newVal) {
                this.$root.$emit("showCheckedSaveBtn", newVal);
            },
            immediate: true
        },
        showEntityTable: {
            handler(val) {
                this.$store.commit("dataStore/setEntitySelected", val);
            },
            immediate: true
        },
        showEntityList: {
            handler(val) {
                this.$root.$emit("hideSaveBtn", val);
            },
            immediate: true
        },
        getEntitySelected: {
            handler(newValue) {
                if (!newValue && this.showEntityTable && this.nothingToSave) {
                    this.resetLinkToList();
                }
            }
        }
    },
    created() {
        this.firstLoad = true;
        this.$root.$off("startEditing");
        this.$root.$off("bc__dataStore__open");
        this.$root.$on("bc__dataStore__open", (code) => {
            this.showEntity({ code });
        });
        this.$root.$on("startEditing", () => {
            this.showEntity({ code: this.activeEntityCode });
        });
        this.$root.$on("refreshdataTables", () => {
            this.resetLinkToList();
        });
        this.$root.$off("bc__selectedEntity__rename");
        this.$root.$on("bc__selectedEntity__rename", data => {
            this.renameEntityFn(data);
        });
        this.$root.$on("oneAtATime-dataStore-delete", msg => {
            if (this.$oneAtATime.state.$currentEditingUser) {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("globalDataModel.alreadyEdited", { userName: this.$oneAtATime.state.$currentEditingUser }),
                    timeout: 3000
                });
                this.$oneAtATime.destroyCurrentRoom();
            } else if (msg === "true") {
                this.deleteTable();
            }
        });
        this.$root.$off("backendWebsocketEvents-refreshDataStoreList");
        this.$root.$on("backendWebsocketEvents-refreshDataStoreList", ({ data }) => {
            const [, action, entityCode, reason] = data.split(":");
            if ((reason === "delete" && (entityCode === this.localEntity.code)) || (reason === "delete" && (entityCode === this.entityForDeletion))) {
                this.updateNotify();
            } else if ((reason === "persist" || reason === "import")
                && entityCode === this.localEntity.code
                && !this.$oneAtATime.state.$currentRoomEmpty
            ) {
                this.updateNotify = this.$toast.showNotify({
                    type: "info",
                    message: `${this.$t("gdmIntegration.theEntity")} ${this.$t("documents.documentUpdateToast")}`,
                    buttonLabel: `${this.$t("documents.refresh")}`,
                    timeout: 0,
                    hasClose: false,
                    code: "updateNotify",
                    actionEvent: () => { this.showEntity({ code: entityCode }); }
                });
            }
            if (action === "refreshList"
                && (
                    (entityCode !== this.entityDataForEdit.code && entityCode !== this.entityForDeletion)
                    || (entityCode === this.entityDataForEdit.code && !this.$oneAtATime.state.$currentRoomEmpty)
                )
            ) {
                this.refreshEntityList({ ev: `WS${reason}`, name: entityCode });
                setTimeout(() => {
                    if (sessionStorage.getItem("currentDataStoreUser") !== "true") {
                        this.$toast.showNotify({
                            type: "info",
                            message: `${this.$t("gdmIntegration.listUpdated")}`,
                            timeout: 5000,
                            hasClose: true,
                            code: "refreshList"
                        });
                    } else {
                        sessionStorage.removeItem("currentDataStoreUser");
                    }
                });
            }
        });
    },
    beforeDestroy() {
        this.$root.$off("backendWebsocketEvents-refreshDataStoreList");
        this.$root.$off("oneAtATime-dataStore-delete");
        this.$root.$off("openChangeHistory");
        this.$oneAtATime.destroyCurrentRoom();
        this.firstLoad = false;
    },
    mounted() {
        if (this.firstLoad) {
            this.$backendWebsocketEvents.startWebsocket("dataStore");
            this.openChangeHistoryModal();
            this.refreshEntityList("activated");
        }
        const [first] = this.sourceOptions;
        first.label = this.$t("globalDataModel.aurachain", { brandName: this.getInfoApp.companyName });
    },
    activated() {
        const { query, params } = this.$route;
        if (query && Object.keys(query).length) {
            if (query.search && this.firstLoad) {
                this.getEntities([]).then(({ data }) => {
                    this.emptyState = !data.length;
                    this.entityList = data;
                    this.search = query.search;
                    this.skeletonState = false;
                });
            } else if (query.search) {
                this.search = query.search;
                this.skeletonState = false;
            }
        } else if (params && params.tableCode) {
            this.getEntities([]).then(({ data }) => {
                this.emptyState = !data.length;
                this.entityList = data;
                this.onClickEntity(params.tableCode);
            });
        } else if (!this.firstLoad) {
            this.$root.$emit("showCheckedSaveBtn", true);
            this.$root.$emit("hideSaveBtn", true);
            this.showEntityTable = false;
            this.refreshEntityList("activated");
            this.nothingToSave = true;
            this.$backendWebsocketEvents.startWebsocket("dataStore");
        }
        if (!this.firstLoad) {
            this.openChangeHistoryModal();
        }
        this.firstLoad = false;
    },
    deactivated() {
        this.showEntityTable = false;
        this.search = "";
        this.updateNotify();
        this.$root.$emit("hideSaveBtn", true);
        this.$oneAtATime.destroyCurrentRoom();
        this.$root.$off("openChangeHistory");
        this.firstLoad = false;
    },
    methods: {
        ...mapActions("dataStore", [
            "getIntegrations",
            "getEntities",
            "getAttributes",
            "getEntityData",
            "getExternalEntityData",
            "deleteEntity",
            "renameEntity"
        ]),
        ...mapMutations(
            "dataStore",
            ["setSelectedEntity"]
        ),
        renameEntityFn(interfaceNameObj) {
            if (interfaceNameObj.newName) {
                this.getSelectedEntity.name = interfaceNameObj.newName;
                const payload = {
                    entityCode: this.getSelectedEntity.code,
                    name: this.getSelectedEntity.name
                };
                this.renameEntity(payload).then(data => {
                    if (data && data.data) {
                        this.refreshEntityList("bc__rename");
                        if (this.$route.params.tableCode !== data.data.name) {
                            this.$router.replace({ params: { tableCode: data.data.name } });
                        }
                        this.$toast.showNotify({
                            type: "success",
                            message: this.$t("globalDataModel.renameEntityToast", { entityName: interfaceNameObj.oldName }),
                            timeout: 2000
                        });
                    }
                }).catch((err) => {
                    if (err.response.status === 409) {
                        this.getSelectedEntity.name = interfaceNameObj.oldName;
                        this.$toast.showNotify({
                            type: "error",
                            message: this.$t("globalDataModel.duplicatedEntityToast"),
                            timeout: 2000
                        });
                    } else if (err.response.status === 400) {
                        this.getSelectedEntity.name = interfaceNameObj.oldName;
                        this.$toast.showNotify({
                            type: "error",
                            message: this.$t("globalDataModel.wrongPatternEntity"),
                            timeout: 2000
                        });
                    }
                });
            } else {
                this.getSelectedEntity.name = interfaceNameObj.oldName;
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("globalDataModel.emptyNameEntity"),
                    timeout: 2000
                });
            }
        },
        setImportDataDisable(value, notPublished) {
            const importDataItem = this.headerOptions.find(elem => elem.value === "importData");
            const exportDataItem = this.headerOptions.find(elem => elem.value === "export");
            if (value) {
                importDataItem.itemDisabled = true;
                exportDataItem.itemDisabled = true;
                importDataItem.tooltipProps = {
                    tooltipContent: notPublished ? this.$t("globalDataModel.noUnpublishedEntity") : this.$t("globalDataModel.importInProgress"),
                    direction: "left"
                };
                exportDataItem.tooltipProps = {
                    tooltipContent: this.$t("globalDataModel.noDataToExport"),
                    direction: "left"
                };
            } else {
                delete importDataItem.itemDisabled;
                delete importDataItem.tooltipProps;
                delete exportDataItem.itemDisabled;
                delete exportDataItem.tooltipProps;
            }
        },
        refreshEntityList(event) {
            let ev;
            let name;
            if (typeof event === "object") {
                ({ ev, name } = event);
            } else {
                ev = event;
            }
            this.skeletonState = true;
            const deleteTableName = this.entityDataForEdit.name;
            this.getEntities([]).then(({ data }) => {
                this.emptyState = false;
                if (!data.length) {
                    this.emptyState = true;
                }
                this.entityList = data;
                this.skeletonState = false;
                this.entityList.sort((prev, next) => prev.name.toLowerCase().localeCompare(next.name.toLowerCase()));
                switch (ev) {
                    case "created":
                        this.search = "";
                        this.showEntityList = false;
                        this.showEntity({ name }, true);
                        break;

                    case "deleted":
                        this.showEntity({});
                        break;
                    case "bc__rename": {
                        const entity = this.entityList.find(item => item.code === this.activeEntityCode);
                        if (entity) {
                            this.selectedEntity = entity.name;
                            this.localEntity = { ...entity };
                            this.entityDataForEdit = { ...entity };
                        }
                        break;
                    }

                    case "edited":
                        this.showEntity({ name }, true);
                        break;

                    case "activated":
                        this.showEntity({});
                        break;

                    case "WSpersist": {
                        const lastEntityIndex = this.entityList.findIndex(item => item.code === this.entityDataForEdit.code);
                        if (lastEntityIndex > -1) {
                            this.selectedEntity = this.entityList[lastEntityIndex].name;
                        }
                    }
                        break;

                    case "WSdelete":
                        if (name === this.entityDataForEdit.code) {
                            this.$oneAtATime.destroyCurrentRoom();
                            this.showEntity({});
                            this.$toast.showNotify({
                                type: "info",
                                message: `${deleteTableName} ${this.$t("documents.deleteBy")} ${this.$oneAtATime.state.$currentEditingUser}.`,
                                timeout: 3000
                            });
                        }
                        break;

                    default:
                        break;
                }
            });
        },
        resetTableData() {
            this.loadingData = true;
            this.loadingDummyColumns = true;
            this.columns = DUMMY_TABLE_COLUMNS;
            this.tableData = DUMMY_TABLE_DATA;
            this.resetCurrentPage = true;
            this.tablePagination = {
                ...this.tablePagination,
                page: 1,
                total: 0,
                from: 0,
                to: this.tablePagination.rowsPerPage
            };
        },
        setColumns(entityCode) {
            const columns = [];
            this.getAttributes(entityCode)
                .then(({ data }) => {
                    this.attributesListToSend = [...data];
                    data.forEach(att => {
                        const column = {
                            id: uid(),
                            code: att.code,
                            type: att.type,
                            name: att.code,
                            label: att.name,
                            field: att.code,
                            align: "left",
                            required: true,
                            isPublished: att.isPublished,
                            personalInfo: att.personalInfo
                        };
                        if (column.code === "id") {
                            columns.unshift(column);
                        } else if (column.type !== "attachment") {
                            columns.push(column);
                        }
                    });
                    columns.unshift({ ...this.deleteColumn });
                    this.columns = columns;
                    this.loadingDummyColumns = false;
                    this.errorRetrievingData = false;
                    this.getData();
                })
                .catch(() => {
                    this.loadingDummyColumns = false;
                });
        },
        onClickEntity(code) {
            this.showEntityList = false;
            this.showEntityTable = true;
            this.showEntity({ code });
            this.okActionEntity = null;
        },
        showEntity({ code = null, name = null } = {}) {
            this.showEntityTable = true;
            this.search = "";
            if (code === null && name === null) {
                this.selectedEntity = "";
                this.localEntity = {};
                this.entityDataForEdit = {};
                this.activeEntityCode = null;
                this.showEntityTable = false;
                this.showEntityList = true;
                this.setSelectedEntity({ name, code });
            } else {
                const entity = this.entityList.find(item => (code && item.code === code) || (name && item.name === name));
                if (!entity) {
                    return this.showEntity({});
                }
                if (this.entityDataForEdit.code !== entity.code) {
                    this.$oneAtATime.createRoom("dataStore", entity.code);
                }
                this.resetTableData();
                this.activeEntityCode = entity.code;
                this.selectedEntity = entity.name;
                this.localEntity = { ...entity };
                this.entityDataForEdit = { ...entity };
                this.setColumns(entity.code);
                this.setSelectedEntity({ code: entity.code, name: entity.name });
                if (this.$route.params.tableCode !== entity.code) {
                    this.$router.replace({ params: { tableCode: entity.code } });
                }
                this.$store.commit("main/setSaveBtnVisible", false);
                this.$root.$emit("showCheckedSaveBtn", true);
            }
            this.resetLinkFromBC = false;

            return undefined;
        },
        getIntegrationList(isCreate) {
            this.getIntegrations().then(integrations => {
                const integrationsList = integrations.data.dbConnections.map(item => ({
                    label: item.connectionName,
                    value: item.connectionCode,
                    dbType: item.dbType
                }));
                integrationsList.unshift(this.sourceOptions[0]);
                this.sourceOptions = [...integrationsList];
                if (isCreate) {
                    this.openCreateEntityModalNew = true;
                    this.openEditModal = false;
                    this.entityDataForEdit = [];
                } else {
                    this.entityDataForEdit = this.localEntity;
                    this.openCreateEntityModalNew = true;
                    this.openEditModal = true;
                }
            });
        },
        refreshData() {
            this.search = "";
            this.resetCurrentPage = true;
            this.tablePagination = {
                ...this.tablePagination,
                page: 1,
                total: 0,
                from: 0,
                to: this.tablePagination.rowsPerPage
            };
            this.getData();
        },
        getData() {
            this.updateNotify();
            this.loadingData = true;
            const payload = {
                entityCode: this.entityDataForEdit.code,
                from: this.tablePagination.from,
                to: this.tablePagination.to
            };
            const request = this.isExternal ? this.getExternalEntityData : this.getEntityData;
            request(payload)
                .then(({ data: { rows: list = [], total = 0 } = {} } = {}) => {
                    this.loadingData = false;
                    if (!list.length && this.columns[0].name === "deleteColumn") {
                        this.columns.splice(0, 1);
                    }
                    if (!list.length) {
                        this.noDataInEntity = true;
                    }
                    this.tablePagination = {
                        ...this.tablePagination,
                        total,
                        page: Math.floor(this.tablePagination.to / this.tablePagination.rowsPerPage)
                    };
                    this.rowIdsSet = new Set();
                    this.tableData = list.map(element => {
                        this.rowIdsSet.add(element.id);
                        const rid = uid();
                        return { ...element, [this.iid]: rid };
                    });
                    this.savedTableData = JSON.parse(JSON.stringify(this.tableData));
                    this.resetCurrentPage = false;
                })
                .catch(() => {
                    if (this.isExternal) {
                        this.errorRetrievingData = true;
                    }
                    this.loadingData = false;
                    this.tableData = [];
                });
        },
        changePagination(data) {
            if (data === "cancel") {
                const { page } = this.tablePagination;
                this.tablePagination.page = 0;
                setTimeout(() => {
                    this.tablePagination.page = page;
                }, 0);
                return;
            }
            const { rowsPerPage = 10, page = 1 } = data || {};
            this.tablePagination = {
                ...this.tablePagination,
                page,
                rowsPerPage,
                from: rowsPerPage * (page - 1),
                to: rowsPerPage * page
            };
            if (this.entityDataForEdit.code) {
                this.getData();
            }
        },
        onClickCreate() {
            this.okActionEntity = null;
            this.openDlg();
        },
        onClickImport() {
            this.openImportEntityModal = true;
        },
        openDlg() {
            this.getIntegrationList(true);
            this.openCreateEntityModalNew = true;
        },
        searchEntities(value) {
            this.search = value.trim();
            const { query } = this.$route;
            if (this.search) {
                const queriesAreDifferent = JSON.stringify({ search: this.search }) !== JSON.stringify(query);
                if (queriesAreDifferent) {
                    this.$router.replace({ query: { search: this.search } });
                }
            } else if (!this.search && query && Object.keys(query).length > 0 && this.$route.name === "dataStore") {
                this.$router.replace({});
            }
        },
        setEntityForDeletion(entity) {
            if (entity) {
                this.entityForDeletion = entity.entityCode;
                this.entityNameForToast = entity.entityName;
                this.deleteEntityDialog = true;
            } else {
                this.entityForDeletion = "";
            }
        },
        clickDeleteTable() {
            this.$oneAtATime.createRoom("dataStore", this.entityForDeletion, "delete");
        },
        deleteTable() {
            this.deleteEntity(this.entityForDeletion).then(
                () => {
                    this.refreshEntityList("deleted");
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("globalDataModel.deletedMsgStore", { entityName: this.entityNameForToast }),
                        timeout: 3000
                    });
                    this.$oneAtATime.destroyCurrentRoom();
                    this.$router.push({ path: "/dataStore/dataTables" });
                }
            ).catch(() => {
                this.$oneAtATime.destroyCurrentRoom();
            });
        },
        resetLinkToList() {
            this.$oneAtATime.destroyCurrentRoom();
            this.resetLinkFromBC = true;
            this.showEntityTable = false;
            this.refreshEntityList("activated");
            this.nothingToSave = true;
            this.$backendWebsocketEvents.startWebsocket("dataStore");
            this.$root.$emit("setReadonlyTag", false);
            this.$root.$emit("hideSaveBtn", true);
        },
        openChangeHistoryModal() {
            this.$root.$off("openChangeHistory");
            this.$root.$on("openChangeHistory", routeName => {
                if (routeName === this.$route.name) {
                    this.changeHistoryModal = true;
                }
            });
        }
    }
};
